import React, { useEffect, useCallback } from "react";
import GeoCalculationItem from "./dto/GeoCalculationItem";
import LayerElement from "../layers/component/LayerElement";
import { GeoCalcStyle } from "./types";
import { GeoCalculationsByIdsServiceParams } from "../api/api-packages";

export interface GeoCalcStateProps {
    enabled: boolean;
    treeItems: GeoCalculationItem[];
    allCalculations: GeoCalculationItem[];
    geoCalcUrlIds?: string[];
    axiosInitialized?: boolean;
    ticket?: string;
    geoCalcStyle: GeoCalcStyle;
}

export interface GeoCalcDispatchProps {
    handleRequestGeoCalcList: () => Promise<GeoCalculationItem[]>;
    handleGeoCalculationAdded: (calculationId: string) => void;
    handleGeoCalculationRemoved: (geoCalculationId: number) => void;
    handleGeoCalculationVisibilityToggled: (geoCalculationId: number, visibility: boolean) => void;
    handleGeoCalculationZoom: (calculationId?: string) => void;
    handleLoadVisualisedGeoCalculation: (geoCalculations: GeoCalculationItem[], style: GeoCalcStyle) => void;
    handleRequestGeoCalculationsByIds: (
        restOptions: GeoCalculationsByIdsServiceParams
    ) => Promise<GeoCalculationItem[]>;
    handleLoadGeoCalcList: (geoCalcList: GeoCalculationItem[]) => void;
}

export const GeoCalc = (props: GeoCalcDispatchProps & GeoCalcStateProps) => {
    const {
        enabled,
        treeItems,
        allCalculations,
        geoCalcUrlIds,
        axiosInitialized,
        geoCalcStyle,
        ticket,
        handleRequestGeoCalcList,
        handleGeoCalculationRemoved,
        handleGeoCalculationVisibilityToggled,
        handleGeoCalculationZoom,
        handleLoadVisualisedGeoCalculation,
        handleRequestGeoCalculationsByIds,
        handleLoadGeoCalcList,
    } = props;

    const handleAddGeoCalculations = useCallback(async (geoCalcIds: string | string[]) => {
        const restOptions: GeoCalculationsByIdsServiceParams = {
            geoCalcIds: typeof geoCalcIds === "string" ? [geoCalcIds] : geoCalcIds,
        };
        const geoCalcItems = await handleRequestGeoCalculationsByIds(restOptions);
        handleLoadVisualisedGeoCalculation(geoCalcItems, geoCalcStyle!);
    }, []);

    const handleOnTreeItemAdd = useCallback(async () => {
        const geoCalcList = await handleRequestGeoCalcList();
        handleLoadGeoCalcList(geoCalcList);
    }, []);

    useEffect(() => {
        if (enabled && axiosInitialized) {
            if (!geoCalcUrlIds) {
                handleLoadVisualisedGeoCalculation([], geoCalcStyle!);
            } else {
                handleAddGeoCalculations(geoCalcUrlIds);
            }
        }
    }, [axiosInitialized, ticket]);

    if (enabled) {
        return (
            <div id={"geoCalc"}>
                <LayerElement
                    className={"geoCalculation"}
                    id={"geoCalculations"}
                    lookUpTitle={"Geo Calculations"}
                    lookupFilterMessage={"Filter Geo Calculations"}
                    treeItems={treeItems}
                    lookUpItems={allCalculations}
                    onTreeItemAdd={handleOnTreeItemAdd}
                    onTreeItemRemove={handleGeoCalculationRemoved}
                    onLookupItemAdd={(geoCalcId) => handleAddGeoCalculations(geoCalcId.toString())}
                    onTreeItemVisibilityChange={handleGeoCalculationVisibilityToggled}
                    onTreeItemClick={handleGeoCalculationZoom}
                />
            </div>
        );
    }
    return null;
};
